import { render, staticRenderFns } from "./index.vue?vue&type=template&id=107a841d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=107a841d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a841d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107a841d')) {
      api.createRecord('107a841d', component.options)
    } else {
      api.reload('107a841d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=107a841d&scoped=true&", function () {
      api.rerender('107a841d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/caseRegister/caseReview/index.vue"
export default component.exports